import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CustomTooltip = ({ image, data }) => {
  const [show, setShow] = useState(false);

  const handleToggle = () => setShow(!show);
  const tooltip = (props) => (
    <Tooltip id="tooltip" {...props} className="custom-tooltip-1">
      <div>
        <div>{data.title}</div>
        <div style={{ fontWeight: "bold" }}>{data.value}</div>
      </div>
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={tooltip}
      trigger="click"
      show={show}
      rootClose
      onToggle={setShow}
    >
      <img
        src={image}
        alt=""
        style={{ cursor: "pointer" }}
        onClick={handleToggle}
      />
    </OverlayTrigger>
  );
};

export default CustomTooltip;
